import { render } from "./LagenschemaEditor.vue?vue&type=template&id=285ae79c&scoped=true"
import script from "./LagenschemaEditor.vue?vue&type=script&lang=js"
export * from "./LagenschemaEditor.vue?vue&type=script&lang=js"

import "./LagenschemaEditor.vue?vue&type=style&index=0&id=285ae79c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-285ae79c"]])

export default __exports__